import { KendoBaseComponent, KendoBaseDatasourceComponent } from '@progress/kendo-base-components-vue-wrapper'
import SparklineProps from './SparklineProps'
import KendoSparklineSeriesItem from './KendoSparklineSeriesItem'

import CategoryAxis from './CategoryAxis'
import ChartArea from './ChartArea'
import PlotArea from './PlotArea'
import SeriesDefaults from './SeriesDefaults'
import Tooltip from './Tooltip'
import ValueAxis from './ValueAxis'

export default {
    props: SparklineProps,
    emits: {
        'kendowidgetready': null
    },
    mixins: [
        KendoBaseComponent,
        KendoBaseDatasourceComponent,
        CategoryAxis,
        ChartArea,
        PlotArea,
        SeriesDefaults,
        Tooltip,
        ValueAxis
    ],
    mounted() {
        this._resolveChildren()

        kendo.jQuery(this.$el).kendoSparkline(this.widgetOptions)

        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', this.kendoWidget())
        } else {
            this.$emit('kendowidgetready', this.kendoWidget())
        }
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoSparkline()
        },
        _resolveChildren() {
            this.resolveChildren('series', KendoSparklineSeriesItem.name)
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoSparkline/KendoSparklineMixin.js